import newsEn from './news/en.json';
import newsZhHant from './news/zh-Hant.json';
import newsTh from './news/th.json';
import newsVi from './news/vi.json';

export default {
  en: newsEn,
  'zh-Hant': newsZhHant,
  vi: newsVi,
  th: newsTh,
};
